export default __webpack_public_path__ + "87da660.png";